import { Heading, Text, Stack } from '@chakra-ui/react';
import { LayoutContainer } from '../common';

export function Hero(): JSX.Element {
  return (
    <LayoutContainer pos="relative" verticalPadding="none">
      <Stack align="center" textAlign="center" spacing={4} py="78px">
        <Heading as="h1" size="h1">
          Pricing built for
          <br />
          <Text
            bgGradient="linear-gradient(271.19deg, #17CCFC -28.89%, #6C47FF 80.53%)"
            bgClip="text"
          >
            businesses of all sizes
          </Text>
        </Heading>

        <Text
          fontSize="24px"
          fontWeight={400}
          display={{ base: 'none', md: 'flex' }}
        >
          Start for free, and scales with your success. We never charge for
          inactive users.
        </Text>
        <Text
          fontSize="16px"
          fontWeight={400}
          display={{ base: 'flex', md: 'none' }}
        >
          Start for free, always know what you'll pay.
        </Text>
      </Stack>
    </LayoutContainer>
  );
}
